import { isMaliciousUrl, normalizeHref } from "./../link/urlValidators";
import { getBasedUrl } from "./get-based-url";
import { isPageUrl } from "./is-page-url";
const getHrefUrl = (url, baseUrl) => typeof url !== "string" ? void 0 : isMaliciousUrl(url) ? void 0 : isPageUrl(url) ? getBasedUrl(url, baseUrl || "") : normalizeHref(url);
export {
  getHrefUrl
};
//# sourceMappingURL=get-href-url.js.map
